import { CreateAircraftGroupAction } from '../actions';
import api from '../../../../../../../../services/api';
import { call, select } from 'redux-saga/effects';
import { getCompanyID } from '../../../../../../../../redux/selectors';
import { loadGroupWorker } from './loadGroupWorker';

export function* updateGroupWorker(action: CreateAircraftGroupAction) {
  const { payload } = action;
  const companyID = yield select(getCompanyID);

  try {
    yield call(api.patch, `/v1/companies/${companyID}/aircraft-group`, payload);
    yield call(loadGroupWorker);
  } catch (err) {
    console.log(err);
  }
}
